import React from 'react';
import {
  convertToPence,
  convertToPounds,
  keepParams,
} from '@homamo/meadow-utils';

import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

import API, { handleApiError } from '../../../lib/api';

import Error from '../../common/ErrorMessage';
import Button, { ButtonGroup } from '../../common/Button';
import Form from '../../common/Form';
import TextInput from '../../common/TextInput';
import CurrencyInput from '../../common/CurrencyInput';
import DateInput from '../../common/DateInput';
import config from '../../../config';

const validationSchema = Yup.object().shape({
  userEmail: Yup.string()
    .email("Whoops! That doesn't look like a valid email")
    .required(`Enter the email address of the user you're paying`),
  amount: Yup.string().required('You need to enter an amount'),
  paymentDate: Yup.string().required('You need to enter a payment date'),
});

const AdminCreatePaymentForm = () => {
  const history = useHistory();
  const [displayError, setDisplayError] = React.useState();

  return (
    <>
      <Error error={displayError} />
      <Formik
        onSubmit={async (values, { setSubmitting }) => {
          await API.post('transactions/create-for-user', {
            userEmail: values.userEmail,
            date: values.paymentDate,
            amount: convertToPence(values.amount),
            type: 'REWARD',
            description: 'REWARD_PAYMENT',
          })
            .then((res) => {
              const transactionId = res.data._id;
              toast.success('Payment created');
              history.push(keepParams(`/admin/payment/${transactionId}`));
            })
            .catch((error) => {
              handleApiError({ error, setDisplayError });
            })
            .finally(() => setSubmitting(false));
        }}
        initialValues={{
          userEmail: undefined,
          amount: convertToPounds(config.rewardDefaults.switch),
          paymentDate: new Date(),
          description: 'RATESWITCH_REWARD',
        }}
        validationSchema={validationSchema}
      >
        {({ isSubmitting }) => {
          return (
            <Form>
              <fieldset disabled={isSubmitting} aria-busy={isSubmitting}>
                <Field
                  label="User email"
                  id="userEmail"
                  name="userEmail"
                  placeholder="Enter a user's email address"
                  component={TextInput}
                  isRequired
                />
                <Field
                  label="Amount"
                  id="amount"
                  name="amount"
                  component={CurrencyInput}
                  isRequired
                />
                <Field
                  label="Payment Date"
                  id="paymentDate"
                  name="paymentDate"
                  component={DateInput}
                  isRequired
                />
                <ButtonGroup>
                  <Button
                    label="Create Payment"
                    type="submit"
                    mode="primary"
                    loadingLabel="Creating Payment"
                    isLoading={isSubmitting}
                  />
                  <Button
                    label="Cancel"
                    onClick={() => history.push(keepParams('/admin/payments'))}
                  />
                </ButtonGroup>
              </fieldset>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default AdminCreatePaymentForm;
